import PropTypes from 'prop-types';
import React from 'react';
import {ThemeProvider as MuiThemeProvider} from '@material-ui/core/styles';

import styles from './Base.css';
import './import.css';


const Base = ({children, muiTheme}) => (
  <MuiThemeProvider theme={muiTheme}>
    <div className={styles.root}>
      {children}
    </div>
  </MuiThemeProvider>
);

Base.propTypes = {
  children: PropTypes.node,
  muiTheme: PropTypes.object,
};

export default Base;



// WEBPACK FOOTER //
// ./src/common/components/Base/Base.js